import { useState, useEffect, createElement } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _require$version$spli = require('../package.json').version.split('.').map(Number),
    major = _require$version$spli[0],
    minor = _require$version$spli[1],
    patch = _require$version$spli[2];

var SDK_VERSION = {
  major: major,
  minor: minor,
  patch: patch
};

var addScriptTag = function addScriptTag(loadCb, url) {
  var tag = document.createElement('script');
  tag.async = true;
  tag.type = 'application/javascript';
  tag.src = url || "https://cdn.getpinwheel.com/pinwheel-v" + major + "." + minor + ".js";
  document.body.appendChild(tag);
  tag.addEventListener('load', function () {
    return loadCb();
  });
  return tag;
};

var PinwheelModal = function PinwheelModal(_ref) {
  var open = _ref.open,
      _srcUrl = _ref._srcUrl,
      props = _objectWithoutPropertiesLoose(_ref, ["open", "_srcUrl"]);

  var _React$useState = useState(false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  var _React$useState2 = useState(false),
      showing = _React$useState2[0],
      setShowing = _React$useState2[1];

  var _React$useState3 = useState(),
      tag = _React$useState3[0],
      setTag = _React$useState3[1];

  useEffect(function () {
    delete window['Pinwheel'];
    setLoaded(false);
    var els = document.querySelectorAll('.pinwheel-portal');
    els.forEach(function (e) {
      var _e$parentNode;

      return (_e$parentNode = e.parentNode) === null || _e$parentNode === void 0 ? void 0 : _e$parentNode.removeChild(e);
    });
    var newTag = addScriptTag(function () {
      return setLoaded(true);
    }, _srcUrl);
    setTag(newTag);
  }, [_srcUrl, setLoaded]);
  useEffect(function () {
    if (tag && tag.parentNode) tag.parentNode.removeChild(tag);
  }, [_srcUrl]);
  useEffect(function () {
    if (!loaded) return;

    if (open && !showing) {
      Pinwheel.open(_extends({}, props, {
        _versionOverride: SDK_VERSION,
        _sdkOverride: 'react'
      }));
      setShowing(true);
    } else if (!open && showing) {
      Pinwheel.close();
      setShowing(false);
    }
  }, [open, showing, setShowing, loaded]);
  return createElement("div", null);
};

export default PinwheelModal;
export { SDK_VERSION };
//# sourceMappingURL=index.modern.js.map
